
<div class="container">

  <div class="container-toggle">
    <mat-slide-toggle class="toggle" (change)="changeToggle($event)" [(ngModel)]="isChecked">{{labelToggle}}</mat-slide-toggle>
  </div>


  @if (isChecked) {
    <data-table
      [title]='"Usuarios"'
      [columns]='columnasUsuarios'
      [configuration]='configurationUsuarios'
      [reloadTable]='recargarTablaUsuarios'
      (active)='inactivateOrActiveUser($event, false)'
      (edit)='editarUsuario($event)'
      (selection)='seleccionadosUsuarios($event)'
      (clickRow)='clickFilaUsuarios($event)'
      [params]='params'
      [url]='urlGetUsersTable'
      (add)='agregarUsuario($event)'
    ></data-table>
  }

  @if (!isChecked) {
    <data-table
      [title]='"Usuarios Inactivos"'
      [columns]='columnasUsuarios'
      [configuration]='configurationUsuariosInactives'
      [reloadTable]='recargarTablaUsuariosInactives'
      (clickRow)='inactivateOrActiveUser($event, true)'
      (active)='inactivateOrActiveUser($event, true)'
      [params]='params2'
      [url]='urlGetUsersTable'
      (add)='agregarUsuario($event)'
    ></data-table>
  }

</div>
